// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-20bda26c] .v-data-table__expanded.v-data-table__expanded__content {\n  background-color: #f1f1f1;\n}", ""]);
// Exports
module.exports = exports;
